import { Close } from '@mui/icons-material';
import { Drawer, DrawerProps, Grid, IconButton } from '@mui/material';
import { ReactNode } from 'react';
import styles from './CustomDrawer.module.scss';

interface CustomDrawerProps {
    isOpen: boolean
    setIsOpen: (value: any) => void
    children: ReactNode
    hideBackdrop?: boolean
    transitionDuration?: number,
    anchor?: DrawerProps["anchor"]
    variant?: "persistent" | "temporary"
    disableScrollLock?: boolean
}

export default function CustomDrawer(props: CustomDrawerProps) {
    const {
        isOpen,
        setIsOpen,
        children,
        hideBackdrop = true,
        transitionDuration = 300,
        anchor = "right",
        variant = "temporary",
        disableScrollLock = false
    } = props

    return (
        <Drawer open={isOpen} onClose={() => setIsOpen(false)} anchor={anchor} variant={variant} hideBackdrop={hideBackdrop} transitionDuration={transitionDuration}
            ModalProps={{
                disableScrollLock
            }}
        >
            <Grid className={styles.SideMenuHeader} container justifyContent="flex-end" alignItems="center">
                <IconButton onClick={() => setIsOpen(false)}>
                    <Close />
                </IconButton>
            </Grid>
            <Grid className={styles.Sidemenu}>
                {children}
            </Grid>
        </Drawer >
    )
}


